import "./AutomationBenefit.css";

export default function AutomationBenefit() {

  const benefits = [
    {
      title: "Faster Application Deployment and Scaling",
      desc: "Containerization accelerates application deployment and supports on-demand scaling, enabling teams to deliver updates faster while efficiently managing traffic spikes and changing workload demands."
    },
    {
      title: "Improved Resource Utilization",
      desc: "Containers ensure optimal use of system resources by running lightweight, isolated environments that reduce overhead and improve infrastructure efficiency."
    },
    {
      title: "Consistent Environments Across Teams",
      desc: "Containers eliminate environment inconsistencies by packaging applications with all dependencies, ensuring reliable performance across development, testing, and production."
    },
    {
      title: "Enhanced Security and Isolation",
      desc: "Each container runs in isolation, reducing the attack surface and improving security through controlled access and compliance-driven configurations."
    },
    {
      title: "Simplified CI/CD Pipelines",
      desc: "Containerized workflows integrate seamlessly with CI/CD pipelines, enabling automated builds, testing, and deployments with minimal manual intervention."
    },
    {
      title: "Faster Recovery and High Availability",
      desc: "Containers support rapid recovery and self-healing mechanisms, ensuring minimal downtime and consistent application availability."
    }
  ];

  return (
    <div id="automation-benefit" className="outsourcemainclass">
      <h2 className="heading">Benefits of IT Outsourcing Services</h2>
      <p className="subheading">
        Delivering Secure, Compliant, and High-Performance CI Solutions
      </p>

      <div className="lists">
        {benefits.map((item, index) => (
          <div className="list" key={index}>
            <h3>{item.title}</h3>
            {/* <div className="line"></div> */}
            <span>{item.desc}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
